const GoodType = {
    VILLA: 'villa',
    STUDIO: 'studio',
    APARTMENT: 'apartment',
    LOFT: 'loft',
    HOME: 'home'
};

module.exports = GoodType;